const STATUS = {
	COMPLETE: 'COMPLETE',
	IN_PROGRESS: 'IN-PROGRESS',
	START: 'START'
};

export default {};

export { STATUS };
